'use strict'

class SolutionSlider {
    constructor() {
        this.SolutionSlider()
    }

    SolutionSlider() {
        const solutionSliders = document.querySelectorAll('.ce-solution-slider')        
        
        solutionSliders.forEach(solutionSlider => {
            const tabs = solutionSlider.querySelectorAll('.tabs-title')
            const tabContents = solutionSlider.querySelectorAll('.tabs-panel')

            tabs.forEach(tab => {
                tab.addEventListener('click', () => {
                    tabs.forEach(tab => tab.classList.remove('is-active'))
                    tabContents.forEach(content => content.classList.remove('is-active'))

                    tab.classList.add('is-active')

                    const tabId = tab.id

                    ;[...tabContents]
                        .find(content => content.id == tabId)
                        .classList.add('is-active')
                })
            })
        })
    }
}

module.exports = SolutionSlider